import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  showMoreLessBtn: {
    marginTop: theme.spacing(),
    padding: 0,
  },
}));

export default useStyles;
